<template>
    <div class="news">
        <div class="hotnews_box">
            <div class="content crumbs">
                <span class="iconfont icon-dingwei"></span>
                <b>当前位置：</b>
                <a href="/">首页</a>
                <a class="cur">交易公开</a>
            </div>
        </div>

        <div
            class="content"
            style="margin-top:10px"
        >
            <card class="search">
                <div class="title">
                    <div class="text">
                        交易公开
                    </div>

                    <div class="search-con">
                        <el-input
                            v-model="pgData.searchcontent"
                            size="middle"
                        >
                            <el-button
                                slot="append"
                                @click="queryData"
                            >搜索</el-button>
                        </el-input>
                    </div>
                </div>

                <search-bar
                    v-model="pgData"
                    @change="queryData"
                ></search-bar>
            </card>

            <card
                class="list"
                v-loading="loadingController"
            >
                <list
                    :data="tableData"
                    :props="{title:'ggname', time:'ggfbtime'}"
                    :href="hrefBuilder"
                >
                    <template slot-scope="scope">
                        <div class="main">
                            【{{scope.row.typename}}】
                            {{scope.row.ggname}}
                        </div>

                        <div class="sub">
                            <span class="sub-item">
                                地区：{{scope.row.cityname}}
                            </span>
                            <span class="sub-item">
                                项目类型：{{scope.row.leixing}}
                            </span>
                            <span
                                v-if="!~['zhongbiaogg', 'ycgg', 'dyly'].indexOf(scope.row.ggtype)"
                                class="sub-item"
                            >
                                截止时间：{{scope.row.ggendtime}}
                            </span>
                        </div>
                    </template>
                </list>

                <my-pagination
                    ref="page"
                    class="page"
                    :action="`/web/index/information/getjyinfopg.json`"
                    v-model="tableData"
                    :search="pgData"
                    :loading.sync="loadingController"
                ></my-pagination>
            </card>
        </div>

    </div>
</template>
  
  <script>
import CONFIG from '@config/config';

import Card from '@components/sys/card';
import List from '@components/sys/list';
import MyPagination from './components/my-pagination';
import SearchBar from '../index/components/search-bar.vue';

export default {
    components: {
        Card,
        List,
        SearchBar,
        MyPagination,
    },
    watch: {
        '$route.query.searchcontent': {
            handler(val) {
                this.updateSearch();
            },
        },
    },
    data() {
        return {
            tableData: [],

            pgData: {
                searchtype: 'ggname',
                searchcontent: this.$route.query.searchcontent || '',
                type: 'zbgg',
                leixing: '',
                citycode: '',
                industrycategory: '',
                featurecode: CONFIG.head.planname,
            },

            types: [],

            loadingController: false,
        };
    },
    methods: {
        hrefBuilder(item) {
            var search = toSearch({
                ggcode: item.ggcode,
                categoryid: item.ggtype,
                featurecode: CONFIG.head.planname,
            });

            // if (/SD/.test(item.ggcode)) {
            //     return `/business/detail-sd${search}`;
            // }

            return `/trade/detail${search}`;
        },
        queryData() {
            this.$refs.page.queryData();
        },
        updateSearch() {
            this.pgData.searchcontent = this.$route.query.searchcontent;

            this.queryData();
        },
    },
    mounted() {},
};
</script>
  
  <style lang="scss" scoped>
@import '@css/var.scss';

.hotnews_box {
    box-shadow: 1px 0px 5px #dedede;
    height: 46px;
    line-height: 46px;
    background-color: #ffffff;

    .crumbs {
        font-size: 16px;
        span {
            display: inline-block;
            margin-bottom: 2px;
            margin-left: 15px;
            padding: 0 0 0 20px;
            height: 21px;
            background: url(/images/map.jpg) no-repeat center 0;
            vertical-align: middle;
            margin-right: 5px;
        }
        b {
            color: #181818;
            font-weight: normal;
        }
        a {
            padding-right: 20px;
            background: url(/images/r-arrow.png) no-repeat right center;
            color: #181818;
            text-decoration: none;
            font-weight: 400;
            &:last-child {
                background: 0 0;
            }
        }

        .cur {
            color: #d1171e;
        }
    }
}

.news {
    margin-bottom: 26px;

    .search {
        .title {
            color: $primaryColor;
            font-size: 18px;
            font-weight: bold;
            border-bottom: solid 1px #d6d6d6;
            overflow: hidden;
            padding-bottom: 25px;
            margin-bottom: 25px;

            .text {
                margin-top: 8px;
                float: left;
            }

            .search-con {
                width: 570px;
                float: right;

                ::v-deep {
                    .el-input__inner {
                        border-color: $primaryColor;
                        border-radius: 0;
                    }

                    .el-input-group__append {
                        border-radius: 0;
                        border-color: $primaryColor;
                        background-color: $primaryColor;
                        color: white;
                    }
                }
            }
        }
    }

    .list {
        min-height: 400px;

        ::v-deep {
            .item + .item {
                border-top: solid 1px #d6d6d6;
                padding-top: 24px;
            }
        }

        .main {
        }

        .sub {
            color: #7d7d7d;
            margin-top: 24px;

            .sub-item {
                & + .sub-item {
                    margin-left: 100px;
                }
            }
        }
    }

    .page {
        margin-top: 1em;
    }
}
</style>
  